import { NgModule } from '@angular/core';

import { GlobalTypeIconPipe } from './global-type-icon-pipe';
import { TemplateTypePipe } from './template-type';
import { Therapy2Pipe } from './therapy';
import { TherapyColorPipe } from './therapy-color-pipe';
import { TherapyIcon2Pipe } from './therapy-icon';
import { TherapySecondaryColorPipe } from './therapy-secondary-color-pipe';
import { TherapyTypePipe } from './therapy-type';
import { WoundLocationPipe } from './wound-location';

@NgModule({
  declarations: [
    Therapy2Pipe,
    TherapyTypePipe,
    TemplateTypePipe,
    TherapyIcon2Pipe,
    WoundLocationPipe,
    TherapyColorPipe,
    TherapySecondaryColorPipe,
    GlobalTypeIconPipe,
  ],
  imports: [],
  exports: [
    Therapy2Pipe,
    TherapyTypePipe,
    TemplateTypePipe,
    TherapyIcon2Pipe,
    WoundLocationPipe,
    TherapyColorPipe,
    TherapySecondaryColorPipe,
    GlobalTypeIconPipe,
  ],
})
export class TherapyTreePipesModule {}
